import { MCP_TOOL_GROUP_TOOLS, mcpToolGroupSchema } from "@esi/shared";
import { useTranslation } from "react-i18next";

/**
 * Under an `mcp.tools.<group>` switch, its tools by name behind a disclosure: the row's help stays
 * one plain sentence, and an admin who needs the names opens the list. Other keys: nothing.
 */
export function McpGroupTools(props: { settingKey: string }) {
  const { t } = useTranslation();
  const group = mcpToolGroupSchema.safeParse(props.settingKey.replace(/^mcp\.tools\./, ""));
  if (!props.settingKey.startsWith("mcp.tools.") || !group.success) {
    return null;
  }
  return (
    <details className="text-xs">
      <summary className="w-fit cursor-pointer font-medium text-fg-muted hover:text-fg">
        {t("settings.behaviour.mcpGroupTools")}
      </summary>
      <ul className="mt-1.5 flex flex-wrap gap-x-3 gap-y-1 font-mono text-fg-secondary">
        {MCP_TOOL_GROUP_TOOLS[group.data].map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </details>
  );
}
